import { AbstractControl, ValidatorFn, Validators } from '@angular/forms';

export function specialCharactersValidator(): ValidatorFn {
   return (c: AbstractControl): { [key: string]: boolean } | null => {
      if (c.value == null || c.value === '') {
         return null;
      }

      const pattern = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/;

      if (pattern.test(c.value)) {
         return { specialcharacters: true };
      }
      return null;
   };
}

export function numericValidator(): ValidatorFn {
   return (c: AbstractControl): { [key: string]: boolean } | null => {
      if (c.value == null || c.value === '') {
         return null;
      }

      const pattern = /^\d+$/;
      if (!pattern.test(c.value)) {
         return { numeric: true };
      }
      return null;
   };
}

export function areaCodeValidator(): ValidatorFn {
   return (c: AbstractControl): { [key: string]: boolean } | null => {
      if (c.value == null || c.value === '') {
         return null;
      }

      const areaCodePattern = /^[2-9][0-9][0-9]$/;
      if (!areaCodePattern.test(c.value)) {
         return { invalidAreaCode: true };
      }
      return null;
   };
}

export function combinedAreaCodeValidator(): ValidatorFn[] {
   return [
      Validators.minLength(3),
      Validators.maxLength(3),
      specialCharactersValidator(),
      numericValidator(),
      areaCodeValidator(),
   ];
}
